var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _c("header", [
      _c("div", { staticClass: "header-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "header-right" }, [
        _c(
          "div",
          { staticClass: "user-info" },
          [
            _c(
              "el-dropdown",
              [
                _c("div", { staticClass: "user-name" }, [
                  _vm._v(
                    "\n            你好，" +
                      _vm._s(_vm.userName) +
                      "\n            "
                  ),
                  _c("i", { staticClass: "el-icon-arrow-down icon user-icon" })
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c("div", { staticClass: "more-info" }, [
                      _c("div", { staticClass: "item" }, [
                        _c("i", { staticClass: "user-img" }),
                        _vm._v(" "),
                        _c("p", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.userName))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _c("img", {
                          staticClass: "icon",
                          staticStyle: {
                            width: "9px",
                            "padding-left": "3px",
                            "padding-right": "3px"
                          },
                          attrs: {
                            src: require("../assets/images/icon_mobile.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "p" }, [
                          _vm._v("手机号码：" + _vm._s(_vm.mobile))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _c("img", {
                          staticClass: "icon",
                          staticStyle: {
                            width: "13px",
                            height: "12px",
                            "padding-left": "1px",
                            "padding-top": "1px"
                          },
                          attrs: {
                            src: require("../assets/images/icon_sid.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "p" }, [
                          _vm._v("销售SID：" + _vm._s(_vm.sid))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../assets/images/icon_type.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "p" }, [
                          _vm._v(
                            "用户类型：" + _vm._s(_vm.getUserType(_vm.userType))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../assets/images/icon_job.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "p" }, [
                          _vm._v("岗位：" + _vm._s(_vm.jobTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../assets/images/icon_dep.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "p" }, [
                          _vm._v("所属架构/酒店：" + _vm._s(_vm.deptName))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "button-long",
                        attrs: { type: "button", value: "退出登录" },
                        on: { click: _vm.logout }
                      })
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main-father" }, [
      _c("main", [
        _c("div", { staticClass: "main-content", style: _vm.style_main }, [
          _c("div", { staticClass: "square" }),
          _vm._v(" "),
          _c("div", { staticClass: "content-head" }),
          _vm._v(" "),
          _c("div", { staticClass: "main-body", style: _vm.style_body }, [
            _c("div", { staticStyle: { height: "4px" } }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content-body" },
              _vm._l(_vm.modules, function(item, index) {
                return _c(
                  "div",
                  {
                    staticClass: "card",
                    on: {
                      click: function($event) {
                        return _vm.goTo(item.pageUrl, item.nameEn, item.name)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: { src: item.icon }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-name" }, [
                      _vm._v(_vm._s(item.name))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-detail" }, [
                      _vm._v(_vm._s(item.description))
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-logo" }, [
      _c("div", { staticClass: "head-logo" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7eb2bc79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb2bc79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = null
// module chunks = 